import { Component, ViewEncapsulation, Input, OnDestroy, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { NotifierService } from '../../../shared/notifier/notifier.service';
import { Subscription } from 'rxjs/Subscription';
import { NgForm } from '@angular/forms';
import * as uuid from 'uuid';
@Component({
    selector: 'app-create-buy-order',
    templateUrl: 'createBuyOrderModal.component.html',
    styleUrls: ['./createBuyOrderModal.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: []
})
export class CreateBuyOrderModalComponent implements OnDestroy {
    buyOrderItem: any = {};
    modalTitle = '';
    buttonText = '';
    subscription: Subscription;
    action: string;
    constructor(public dialogRef: MatDialogRef<CreateBuyOrderModalComponent>,
        private notifierService: NotifierService,
        private zone: NgZone) {

        this.handleNotify();
    }

    handleNotify() {
        this.subscription = this.notifierService.behaviorNotifierObject$.subscribe(
            message => {
                this.zone.run(() => {
                    this.action = message.action;
                    // tslint:disable-next-line:triple-equals
                    if (message.action == 'edit' && message.model == 'buyOrder') {
                        this.buyOrderItem = message.object.data;
                        this.buttonText = 'Actualizar';
                        this.modalTitle = 'Editar Detalle de OC';
                        // tslint:disable-next-line:triple-equals
                    } else if (message.action == 'register' && message.model == 'buyOrder') {
                        this.buyOrderItem = message.object.data;
                        this.buyOrderItem.create_uuid = uuid.v4();
                        this.buttonText = 'Crear';
                        this.modalTitle = 'Crear Detalle de OC';
                    }
                });

            }
        );
    }

    update(form: NgForm) {
        if (form.valid) {
            if (this.buyOrderItem.id) {
                this.buyOrderItem.action_backend = 'U';
            } else {
                this.buyOrderItem.action_backend = 'C';
            }
            this.dialogRef.close(this.buyOrderItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete los campos obligatorios',
                type: 'error'
            });
        }
    }

    create(form: NgForm) {
        if (form.valid) {
            this.buyOrderItem.action_backend = 'C';
            this.dialogRef.close(this.buyOrderItem);
        } else {
            this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor complete los campos obligatorios',
                type: 'error'
            });
        }
    }

    close() {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/system/buy-order/new-buy-order/createBuyOrderModal/createBuyOrderModal.component.ts